// import React from 'react';
// import Select from 'react-select';
// import { useTranslation } from 'react-i18next';
// import { type FormikProps } from 'formik';
// import useGetItemsList from '@hooks/INV/MasterItems/useGetItemsList';
// import Loading from '@components/Shared/Loader/Loading';
// import useGetNonInventoryItems from '@hooks/INV/MasterItems/useGetNonInventoryItems';
// import useGetInventoryItemsByOperatingUnitId from '@hooks/INV/MasterItems/useGetInventoryItemsByOperatingUnitId';

// interface LinesProps {
//   formik: FormikProps<any>;
// }

// const PoMultiInvLines: React.FC<LinesProps> = ({ formik }) => {
//   const { values } = formik;
//   const { i18n, t } = useTranslation();
//   const { loading, error } = useGetItemsList();
//   const { NonInventoryItemsOptions = [] } = useGetNonInventoryItems();

//   const { InventoryItemsByOperatingUnitId: data = [] } = useGetInventoryItemsByOperatingUnitId({
//     OperatingUnitId: values.organizationId
//   });

//   // دالة مساعدة للحصول على ItemData بناءً على inventoryId
//   const getItemData = (inventoryId: any) => {
//     return (
//       data
//         .find(f => f.inventoryId === inventoryId)
//         ?.['listInventoryItems']?.map((item: any) => ({
//           label: i18n.language === 'en' ? item.name : item.name,
//           value: item.itemId,
//           itemId: item.itemId,
//           itemCode: item.itemCode,
//           uom: item.unitOfMeasure,
//           uomName: `${i18n.language === 'en' ? item.unitOfMeasureName : item.unitOfMeasureName2}`,
//           isPrimaryUOM: item.isPrimaryUOM,
//           purchasePrice: item.purchasePrice
//         })) || []
//     );
//   };

//   // دالة مساعدة للعثور على صنف معين
//   const findItem = (inventoryId: any, itemId: any) => {
//     const inventory = data.find(f => f.inventoryId === inventoryId);
//     return inventory?.['listInventoryItems']?.find((item: any) => item.itemId === itemId);
//   };

//   // console.log( InventoryItemsByOperatingUnitId);

//   const handleLineChange = (index: number, field: string, value: any) => {
//     const updatedLines = [...values.transactionsLinesList];

//     // ✅ عند تغيير المخزن داخل السطر: لازم نصفر الصنف وبياناته (لمنع عدم تطابق الصنف مع المخزن الجديد)
//     if (field === 'inventoryId') {
//       updatedLines[index] = {
//         ...updatedLines[index],
//         inventoryId: value,
//         itemId: null,
//         description: '',
//         uom: null,
//         price: 0,
//         total: 0,
//         discountAmount: 0,
//         vatAmount: 0
//       };

//       formik?.setFieldValue('transactionsLinesList', updatedLines);
//       return;
//     }

//     // ✅ اختيار الصنف (Inventory / Non-Inventory)
//     if (field === 'itemId') {
//       // عند مسح الاختيار
//       if (value === null) {
//         updatedLines[index] = {
//           ...updatedLines[index],
//           itemId: null,
//           description: '',
//           uom: null,
//           price: 0,
//           total: 0,
//           discountAmount: 0,
//           vatAmount: 0
//         };

//         formik?.setFieldValue('transactionsLinesList', updatedLines);
//         return;
//       }

//       // Inventory Item
//       if ((updatedLines[index].itemType || 'InventoryItem') === 'InventoryItem') {
//         const currentInventoryId = updatedLines[index].inventoryId;
//         const selectedItem = findItem(currentInventoryId, value);

//         if (selectedItem) {
//           const desc = i18n.language === 'en' ? selectedItem.name : selectedItem.name;
//           const price = selectedItem.purchasePrice || 0;

//           const total = Number(updatedLines[index].qty) * Number(price);
//           const discountAmount = (total * Number(updatedLines[index].discountRate || 0)) / 100;
//           const amountAfterDiscount = total - discountAmount;
//           const vatAmount = (amountAfterDiscount * Number(updatedLines[index].vatRate || 0)) / 100;

//           updatedLines[index] = {
//             ...updatedLines[index],
//             itemId: value,
//             price: Number(price),
//             total: amountAfterDiscount,
//             discountAmount,
//             vatAmount,
//             description: desc,
//             uom: selectedItem.unitOfMeasure
//           };

//           formik?.setFieldValue('transactionsLinesList', updatedLines);
//           return;
//         }

//         // fallback إذا لم نجد الصنف
//         updatedLines[index] = {
//           ...updatedLines[index],
//           itemId: value
//         };

//         formik?.setFieldValue('transactionsLinesList', updatedLines);
//         return;
//       }

//       // Non-Inventory Item (Expense / FixedAsset / Service)
//       const currentType = updatedLines[index].itemType;
//       const selectedNonInv =
//         (NonInventoryItemsOptions as any[])?.find((x: any) => x.value === value || x.itemId === value) ??
//         (NonInventoryItemsOptions as any[])?.find((x: any) => x.itemId === value);

//       const desc = selectedNonInv?.itemName ?? selectedNonInv?.label ?? '';
//       const uom =
//         (NonInventoryItemsOptions as any[])
//           ?.filter((x: any) => x.itemType === currentType)
//           ?.find((x: any) => (x.value === value || x.itemId === value) && x.isPrimaryUOM === true)?.uom ??
//         selectedNonInv?.uom ??
//         null;

//       const total = Number(updatedLines[index].qty) * Number(updatedLines[index].price || 0);
//       const discountAmount = (total * Number(updatedLines[index].discountRate || 0)) / 100;
//       const amountAfterDiscount = total - discountAmount;
//       const vatAmount = (amountAfterDiscount * Number(updatedLines[index].vatRate || 0)) / 100;

//       updatedLines[index] = {
//         ...updatedLines[index],
//         itemId: value,
//         description: desc,
//         uom,
//         total: amountAfterDiscount,
//         discountAmount,
//         vatAmount
//       };

//       formik?.setFieldValue('transactionsLinesList', updatedLines);
//       return;
//     }

//     if (field === 'itemType') {
//       // if (value !== 'InventoryItem') {
//       updatedLines[index] = {
//         ...updatedLines[index],
//         itemType: value,
//         itemId: null,
//         description: '',
//         uom: null,
//         inventoryId: null,
//         price: 0,
//         total: 0,
//         discountAmount: 0,
//         vatAmount: 0
//       };
//       formik?.setFieldValue('transactionsLinesList', updatedLines);
//       return;
//       // }
//     }

//     updatedLines[index] = {
//       ...updatedLines[index],
//       [field]: value
//     };

//     // Recalculate total and VAT if needed
//     if (field === 'qty' || field === 'price' || field === 'vatRate' || field === 'discountRate') {
//       const total = Number(updatedLines[index].qty) * Number(updatedLines[index].price);
//       const discountAmount = (total * Number(updatedLines[index].discountRate || 0)) / 100;
//       const amountAfterDiscount = total - discountAmount;
//       const vatAmount = (amountAfterDiscount * Number(updatedLines[index].vatRate || 0)) / 100;

//       updatedLines[index] = {
//         ...updatedLines[index],
//         total: amountAfterDiscount,
//         discountAmount,
//         vatAmount
//       };
//     }

//     formik?.setFieldValue('transactionsLinesList', updatedLines);
//   };

//   const handleAddLine = () => {
//     const newLine = {
//       itemType: 'InventoryItem',
//       itemId: null,
//       lineNumber: values.transactionsLinesList?.length + 1,
//       uom: '',
//       price: 0,
//       qty: 1,
//       discountRate: 0,
//       discountAmount: 0,
//       vatRate: 15,
//       total: 0,
//       vatAmount: 0,
//       description: '',
//       id: null,
//       inventoryId: null
//     };
//     formik.setFieldValue('transactionsLinesList', [...formik.values.transactionsLinesList, newLine]);
//   };

//   const handleDeleteLine = (index: number) => {
//     const updatedLines = values.transactionsLinesList?.filter((_: any, i: number) => i !== index);
//     formik?.setFieldValue('transactionsLinesList', updatedLines);
//   };

//   const calculateTotalSum = () => {
//     const total = values.transactionsLinesList.reduce((sum: any, line: any) => sum + line.total, 0);
//     const formattedTotal = new Intl.NumberFormat('en-US').format(total);
//     return formattedTotal;
//   };

//   const calculateVatSum = () => {
//     const vatTotal = values.transactionsLinesList.reduce((sum: any, line: any) => sum + (line.vatAmount || 0), 0);
//     const formattedVatTotal = new Intl.NumberFormat('en-US').format(vatTotal);
//     return formattedVatTotal;
//   };

//   const calculateNetTotal = () => {
//     const total = values.transactionsLinesList.reduce((sum: any, line: any) => sum + line.total, 0);
//     const vatTotal = values.transactionsLinesList.reduce((sum: any, line: any) => sum + (line.vatAmount || 0), 0);
//     const netTotal = total + vatTotal;
//     const formattedNetTotal = new Intl.NumberFormat('en-US').format(netTotal);
//     return formattedNetTotal;
//   };

//   //----------------------------------------------------------------

//   // console.log(values.transactionsLinesList);

//   return (
//     <>
//       <Loading loading={loading} error={error} Type='Dots'>
//         <div className='  shadow-sm mb-4'>
//           <div className='card-header bg-secondary bg-opacity-25 d-flex justify-content-between align-items-center'>
//             <div className='d-flex align-items-center gap-3'>
//               <div className='fw-bold text-end'>
//                 {t('الإجمالي')}:<span className='text-theme fs-5 fw-bold ms-1'> {calculateTotalSum()}</span>
//               </div>
//               <div className='fw-bold text-end'>
//                 {t('VAT')}:<span className='text-theme fs-5 fw-bold ms-1'> {calculateVatSum()}</span>
//               </div>
//               <div className='fw-bold text-end'>
//                 {t('الصافي')}:<span className='text-theme fs-5 fw-bold ms-1'> {calculateNetTotal()}</span>
//               </div>
//             </div>

//             <button type='button' className='btn btn-theme btn-sm' onClick={handleAddLine}>
//               <i className='fas fa-plus me-2'></i>
//               {t('إضافة بند جديد')}
//             </button>
//           </div>

//           <div className='card-body p-0'>
//             {values.transactionsLinesList?.length > 0 ? (
//               <div className='table-responsive'>
//                 <div
//                   style={{
//                     width: '140%',
//                     maxHeight: '350px',
//                     overflowY: 'auto',
//                     overflowX: 'auto',
//                     position: 'relative'
//                   }}
//                 >
//                   <table className='table table-hover align-middle mb-0'>
//                     <thead className=' bg-theme bg-opacity-60 sticky-top shadow-lg' style={{ top: 0 }}>
//                       <tr>
//                         <th className=' text-center bg-theme bg-opacity-80' style={{ width: '20px' }}>
//                           #
//                         </th>
//                         <th style={{ width: '90px' }}>{t('نوع الصنف')}</th>
//                         <th style={{ width: '200px' }}>{t('المخـزن')}</th>
//                         <th style={{ width: '350px' }}>{t('الصنف')}</th>
//                         <th style={{ width: '103px' }}>{t('الوحدة')}</th>
//                         <th style={{ width: '20px' }}>{t('الكمية')}</th>
//                         <th style={{ width: '20px' }}>{t('السعر')}</th>
//                         <th style={{ width: '30px' }}>{t('نسبة الخصم')}</th>
//                         <th style={{ width: '40px' }}>{t('قيمة الخصم')}</th>
//                         <th style={{ width: '40px' }}>VAT %</th>
//                         <th style={{ width: '40px' }}>{t('VAT')}</th>
//                         <th style={{ width: '40px' }}>{t('Total')}</th>
//                         <th style={{ width: '10px' }}></th>
//                       </tr>
//                     </thead>

//                     <tbody>
//                       {values.transactionsLinesList.map((line: any, index: number) => {
//                         // const ItemData = data
//                         //   .find(f => f.inventoryId === line.inventoryId)
//                         //   ?.['listInventoryItems']?.map((item: any) => ({
//                         //     label: i18n.language === 'en' ? item.name : item.name,
//                         //     value: item.itemId,
//                         //     itemId: item.itemId,
//                         //     itemCode: item.itemCode,
//                         //     uom: item.unitOfMeasure,
//                         //     uomName: `${i18n.language === 'en' ? item.unitOfMeasureName : item.unitOfMeasureName2}`,
//                         //     isPrimaryUOM: item.isPrimaryUOM
//                         //   }));

//                         // console.log(ItemData);

//                         return (
//                           <tr
//                             key={index}
//                             className=''
//                             title={
//                               (line.itemType === 'InventoryItem'
//                                 ? getItemData(line.inventoryId).find((option: any) => option.value === line.itemId)
//                                     ?.label
//                                 : (
//                                     NonInventoryItemsOptions.filter(item => item.itemType === line.itemType) as any
//                                   ).find((option: any) => option.value === line.itemId)?.label) || ''
//                             }
//                           >
//                             <td className='   fw-semibold text-center bg-theme bg-opacity-80'>{index + 1}</td>
//                             <td>
//                               <select
//                                 className='form-select form-select-sm'
//                                 value={line.itemType || ''}
//                                 onChange={e => handleLineChange(index, 'itemType', e.target.value)}
//                               >
//                                 <option value='InventoryItem'>{i18n.language === 'en' ? 'inventory' : 'مخزني'}</option>
//                                 <option value='ExpenseItem'>{i18n.language === 'en' ? 'Expense' : 'مصروف'}</option>
//                                 <option value='FixedAssetItem'>
//                                   {i18n.language === 'en' ? 'Fixed Asset' : 'أصـل'}
//                                 </option>
//                                 <option value='ServiceItem'>{i18n.language === 'en' ? 'Service' : 'خدمي'}</option>
//                               </select>
//                             </td>
//                             <td>
//                               <Select
//                                 isDisabled={line.itemType !== 'InventoryItem'}
//                                 className={`  ${line.itemType !== 'InventoryItem' && 'bg-light'}`}
//                                 classNamePrefix='react-select'
//                                 // className='react-select-container'
//                                 isSearchable
//                                 isClearable
//                                 // options={InventoriesByOperatingUnitId}
//                                 options={data.map(m => ({
//                                   label: i18n.language === 'en' ? m.inventoryName : m.inventoryName2,
//                                   value: m.inventoryId
//                                 }))}
//                                 onChange={option =>
//                                   handleLineChange(index, 'inventoryId', option === null ? null : option.value)
//                                 }
//                                 value={
//                                   line.inventoryId === null
//                                     ? null
//                                     : data
//                                         .map(m => ({
//                                           label: i18n.language === 'en' ? m.inventoryName : m.inventoryName2,
//                                           value: m.inventoryId
//                                         }))
//                                         .find((option: any) => option.value === line.inventoryId)
//                                 }
//                                 placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//                                 menuPortalTarget={document.body}
//                                 styles={{
//                                   menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
//                                   control: base => ({
//                                     ...base,
//                                     minHeight: '20px',
//                                     height: '20px'
//                                   })
//                                 }}
//                                 menuPlacement='auto'
//                               />
//                             </td>

//                             <td>
//                               {line.itemType === 'InventoryItem' ? (
//                                 <Select
//                                   classNamePrefix='react-select'
//                                   className='react-select-container'
//                                   isSearchable
//                                   isClearable
//                                   // options={ItemData}
//                                   options={getItemData(line.inventoryId)}
//                                   onChange={option =>
//                                     handleLineChange(index, 'itemId', option === null ? null : option.value)
//                                   }
//                                   value={
//                                     line.itemId === null
//                                       ? null
//                                       : getItemData(line.inventoryId).find(
//                                           (option: any) => option.value === line.itemId
//                                         )
//                                   }
//                                   placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//                                   menuPortalTarget={document.body}
//                                   styles={{
//                                     menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
//                                     control: base => ({
//                                       ...base,
//                                       minHeight: '31px',
//                                       height: '31px'
//                                     })
//                                   }}
//                                   menuPlacement='auto'
//                                 />
//                               ) : (
//                                 <Select
//                                   classNamePrefix='react-select'
//                                   className='react-select-container'
//                                   isSearchable
//                                   isClearable
//                                   options={
//                                     NonInventoryItemsOptions.filter(item => item.itemType === line.itemType) as any
//                                   }
//                                   onChange={option =>
//                                     handleLineChange(index, 'itemId', option === null ? null : option.value)
//                                   }
//                                   value={
//                                     line.itemId === null
//                                       ? null
//                                       : (
//                                           NonInventoryItemsOptions.filter(
//                                             item => item.itemType === line.itemType
//                                           ) as any
//                                         ).find((option: any) => option.value === line.itemId)
//                                   }
//                                   placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//                                   menuPortalTarget={document.body}
//                                   styles={{
//                                     menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
//                                     control: base => ({
//                                       ...base,
//                                       minHeight: '31px',
//                                       height: '31px'
//                                     })
//                                   }}
//                                 />
//                               )}
//                             </td>

//                             <td>
//                               {line.itemType === 'InventoryItem' ? (
//                                 <select
//                                   disabled={!line.itemId}
//                                   className={`form-select form-select-sm ${!line.itemId && 'bg-light'}`}
//                                   value={line.uom || ''}
//                                   onChange={e => handleLineChange(index, 'uom', e.target.value)}
//                                 >
//                                   <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
//                                   {/* {ItemData?.filter((f: any) => f.itemId === line.itemId)?.map(
//                                     (item: any, idx: any) => (
//                                       <option key={idx} value={item.uom}>
//                                         {item.uomName}
//                                       </option>
//                                     )
//                                   )} */}
//                                   {getItemData(line.inventoryId)
//                                     .filter((f: any) => f.itemId === line.itemId)
//                                     ?.map((item: any, idx: any) => (
//                                       <option key={idx} value={item.uom}>
//                                         {item.uomName}
//                                       </option>
//                                     ))}
//                                 </select>
//                               ) : (
//                                 <select
//                                   className={`form-select form-select-sm`}
//                                   value={line.uom || ''}
//                                   onChange={e => handleLineChange(index, 'uom', e.target.value)}
//                                 >
//                                   <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>

//                                   {NonInventoryItemsOptions?.filter(f => f.itemId === line.itemId)?.map((item, idx) => (
//                                     <option key={idx} value={item.uom}>
//                                       {item.uomName}
//                                     </option>
//                                   ))}
//                                 </select>
//                               )}
//                             </td>

//                             <td>
//                               <input
//                                 type='text'
//                                 min='0'
//                                 step='1'
//                                 className='form-control form-control-sm'
//                                 value={line.qty}
//                                 onChange={e => handleLineChange(index, 'qty', Number(e.target.value))}
//                                 onInput={e => {
//                                   const input = e.target as HTMLInputElement;
//                                   input.value = input.value?.replace(/[^0-9]/g, '');
//                                 }}
//                               />
//                             </td>

//                             <td>
//                               <div className='input-group input-group-sm'>
//                                 {/* <span className='input-group-text'>$</span> */}
//                                 <input
//                                   type='text'
//                                   min='0'
//                                   step='0.01'
//                                   className='form-control'
//                                   value={line.price}
//                                   onChange={e => handleLineChange(index, 'price', Number(e.target.value))}
//                                   onInput={e => {
//                                     const input = e.target as HTMLInputElement;
//                                     input.value = input.value?.replace(/[^0-9]/g, '');
//                                   }}
//                                 />
//                               </div>
//                             </td>

//                             <td>
//                               <div className='input-group input-group-sm'>
//                                 <input
//                                   type='text'
//                                   min='0'
//                                   max='100'
//                                   step='0.01'
//                                   className='form-control'
//                                   value={line.discountRate}
//                                   onChange={e => handleLineChange(index, 'discountRate', Number(e.target.value))}
//                                   onInput={e => {
//                                     const input = e.target as HTMLInputElement;
//                                     input.value = input.value?.replace(/[^0-9]/g, '');
//                                   }}
//                                 />
//                                 {/* <span className='input-group-text'>%</span> */}
//                               </div>
//                             </td>

//                             <td className='fw-semibold'>
//                               {new Intl.NumberFormat('en-US', {
//                                 minimumFractionDigits: 0,
//                                 maximumFractionDigits: 0
//                               }).format(line.discountAmount || 0)}
//                             </td>

//                             <td>
//                               <div className='input-group input-group-sm'>
//                                 <input
//                                   type='text'
//                                   min='0'
//                                   step='0.01'
//                                   className='form-control'
//                                   value={line.vatRate}
//                                   onChange={e => handleLineChange(index, 'vatRate', Number(e.target.value))}
//                                   onInput={e => {
//                                     const input = e.target as HTMLInputElement;
//                                     input.value = input.value?.replace(/[^0-9]/g, '');
//                                   }}
//                                 />
//                                 {/* <span className='input-group-text'>%</span> */}
//                               </div>
//                             </td>

//                             <td className='fw-semibold'>
//                               {new Intl.NumberFormat('en-US', {
//                                 minimumFractionDigits: 0,
//                                 maximumFractionDigits: 0
//                               }).format(line.vatAmount || 0)}
//                             </td>

//                             <td className='fw-bold text-primary'>
//                               {new Intl.NumberFormat('en-US', {
//                                 minimumFractionDigits: 0,
//                                 maximumFractionDigits: 0
//                               }).format(line.total || 0)}
//                             </td>

//                             <td className='text-center'>
//                               <button
//                                 type='button'
//                                 className='btn btn-sm btn-outline-danger'
//                                 onClick={() => handleDeleteLine(index)}
//                                 title={t('Delete Line')}
//                               >
//                                 <i className='fas fa-trash-alt'></i>
//                               </button>
//                             </td>
//                           </tr>
//                         );
//                       })}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//             ) : (
//               <div className='text-center py-5 text-muted'>
//                 <i className='fas fa-receipt fa-3x mb-3'></i>
//                 <p>{t('No items added to this order')}</p>
//                 <button type='button' className='btn btn-primary mt-2' onClick={handleAddLine}>
//                   <i className='fas fa-plus me-2'></i>
//                   {t('Add First Item')}
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>
//       </Loading>
//     </>
//   );
// };

// export default PoMultiInvLines;

import React, { useMemo } from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { type FormikProps } from 'formik';
import Loading from '@components/Shared/Loader/Loading';
import useGetItemsList from '@hooks/INV/MasterItems/useGetItemsList';
import useGetNonInventoryItems from '@hooks/INV/MasterItems/useGetNonInventoryItems';
import useGetInventoryItemsByOperatingUnitId from '@hooks/INV/MasterItems/useGetInventoryItemsByOperatingUnitId';
import { NumericFormat } from 'react-number-format';
import { Card } from '@components/card/card';

interface LinesProps {
  formik: FormikProps<any>;
  maxTableHeight?: string;
}

const PoMultiInvLines: React.FC<LinesProps> = ({ formik, maxTableHeight = '500px' }) => {
  const { values } = formik;
  const { i18n, t } = useTranslation();
  const { loading, error } = useGetItemsList();
  const { NonInventoryItemsOptions = [] } = useGetNonInventoryItems();

  const { InventoryItemsByOperatingUnitId: data = [] } = useGetInventoryItemsByOperatingUnitId({
    OperatingUnitId: values.organizationId
  });

  const formatNumber = (value: number) =>
    new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value || 0));

  const getItemData = useMemo(() => {
    return (inventoryId: any) => {
      return (
        data
          .find(f => f.inventoryId === inventoryId)
          ?.['listInventoryItems']?.map((item: any) => ({
            label: i18n.language === 'en' ? item.name : item.name,
            value: item.itemId,
            itemId: item.itemId,
            itemCode: item.itemCode,
            uom: item.unitOfMeasure,
            uomName: `${i18n.language === 'en' ? item.unitOfMeasureName : item.unitOfMeasureName2}`,
            isPrimaryUOM: item.isPrimaryUOM,
            purchasePrice: item.purchasePrice
          })) || []
      );
    };
  }, [data, i18n.language]);

  const findItem = useMemo(() => {
    return (inventoryId: any, itemId: any) => {
      const inventory = data.find(f => f.inventoryId === inventoryId);
      return inventory?.['listInventoryItems']?.find((item: any) => item.itemId === itemId);
    };
  }, [data]);

  const handleLineChange = (index: number, field: string, value: any) => {
    const updatedLines = [...(values.transactionsLinesList || [])];

    if (field === 'inventoryId') {
      updatedLines[index] = {
        ...updatedLines[index],
        inventoryId: value,
        itemId: null,
        description: '',
        uom: null,
        price: 0,
        total: 0,
        discountAmount: 0,
        vatAmount: 0
      };

      formik?.setFieldValue('transactionsLinesList', updatedLines);
      return;
    }

    if (field === 'itemId') {
      if (value === null) {
        updatedLines[index] = {
          ...updatedLines[index],
          itemId: null,
          description: '',
          uom: null,
          price: 0,
          total: 0,
          discountAmount: 0,
          vatAmount: 0
        };

        formik?.setFieldValue('transactionsLinesList', updatedLines);
        return;
      }

      const currentType = updatedLines[index].itemType || 'InventoryItem';

      if (currentType === 'InventoryItem') {
        const currentInventoryId = updatedLines[index].inventoryId;
        const selectedItem = findItem(currentInventoryId, value);

        if (selectedItem) {
          const desc = i18n.language === 'en' ? selectedItem.name : selectedItem.name;
          const price = selectedItem.purchasePrice || 0;
          const qty = Number(updatedLines[index].qty || 0);
          const discountRate = Number(updatedLines[index].discountRate || 0);
          const vatRate = Number(updatedLines[index].vatRate || 15);

          const total = qty * price;
          const discountAmount = (total * discountRate) / 100;
          const amountAfterDiscount = total - discountAmount;
          const vatAmount = (amountAfterDiscount * vatRate) / 100;

          updatedLines[index] = {
            ...updatedLines[index],
            itemId: value,
            price: Number(price),
            total: amountAfterDiscount,
            discountAmount,
            vatAmount,
            description: desc,
            uom: selectedItem.unitOfMeasure
          };

          formik?.setFieldValue('transactionsLinesList', updatedLines);
          return;
        }

        updatedLines[index] = {
          ...updatedLines[index],
          itemId: value
        };

        formik?.setFieldValue('transactionsLinesList', updatedLines);
        return;
      }

      const selectedNonInv = (NonInventoryItemsOptions as any[])?.find(
        (x: any) => x.value === value || x.itemId === value
      );

      const desc = selectedNonInv?.itemName ?? selectedNonInv?.label ?? '';
      const uom =
        (NonInventoryItemsOptions as any[])
          ?.filter((x: any) => x.itemType === currentType)
          ?.find((x: any) => (x.value === value || x.itemId === value) && x.isPrimaryUOM === true)?.uom ??
        selectedNonInv?.uom ??
        null;

      const qty = Number(updatedLines[index].qty || 0);
      const price = Number(updatedLines[index].price || 0);
      const discountRate = Number(updatedLines[index].discountRate || 0);
      const vatRate = Number(updatedLines[index].vatRate || 15);

      const total = qty * price;
      const discountAmount = (total * discountRate) / 100;
      const amountAfterDiscount = total - discountAmount;
      const vatAmount = (amountAfterDiscount * vatRate) / 100;

      updatedLines[index] = {
        ...updatedLines[index],
        itemId: value,
        description: desc,
        uom,
        total: amountAfterDiscount,
        discountAmount,
        vatAmount
      };

      formik?.setFieldValue('transactionsLinesList', updatedLines);
      return;
    }

    if (field === 'itemType') {
      updatedLines[index] = {
        ...updatedLines[index],
        itemType: value,
        itemId: null,
        description: '',
        uom: null,
        inventoryId: null,
        price: 0,
        total: 0,
        discountAmount: 0,
        vatAmount: 0
      };
      formik?.setFieldValue('transactionsLinesList', updatedLines);
      return;
    }

    updatedLines[index] = {
      ...updatedLines[index],
      [field]: value
    };

    if (['qty', 'price', 'vatRate', 'discountRate'].includes(field)) {
      const qty = Number(updatedLines[index].qty || 0);
      const price = Number(updatedLines[index].price || 0);
      const discountRate = Number(updatedLines[index].discountRate || 0);
      const vatRate = Number(updatedLines[index].vatRate || 15);

      const total = qty * price;
      const discountAmount = (total * discountRate) / 100;
      const amountAfterDiscount = total - discountAmount;
      const vatAmount = (amountAfterDiscount * vatRate) / 100;

      updatedLines[index] = {
        ...updatedLines[index],
        total: amountAfterDiscount,
        discountAmount,
        vatAmount
      };
    }

    formik?.setFieldValue('transactionsLinesList', updatedLines);
  };

  const handleAddLine = () => {
    const newLine = {
      itemType: 'InventoryItem',
      itemId: null,
      lineNumber: (values.transactionsLinesList?.length || 0) + 1,
      uom: '',
      price: 0,
      qty: 1,
      discountRate: 0,
      discountAmount: 0,
      vatRate: 15,
      total: 0,
      vatAmount: 0,
      description: '',
      id: null,
      inventoryId: null
    };
    formik.setFieldValue('transactionsLinesList', [...(formik.values.transactionsLinesList || []), newLine]);
  };

  const handleDeleteLine = (index: number) => {
    const updatedLines = (values.transactionsLinesList || []).filter((_: any, i: number) => i !== index);
    formik?.setFieldValue('transactionsLinesList', updatedLines);
  };

  const calculateTotalSum = () => {
    const total = (values.transactionsLinesList || []).reduce(
      (sum: number, line: any) => sum + Number(line.total || 0),
      0
    );
    return formatNumber(total);
  };

  const calculateVatSum = () => {
    const vatTotal = (values.transactionsLinesList || []).reduce(
      (sum: number, line: any) => sum + Number(line.vatAmount || 0),
      0
    );
    return formatNumber(vatTotal);
  };

  const calculateNetTotal = () => {
    const total = (values.transactionsLinesList || []).reduce(
      (sum: number, line: any) => sum + Number(line.total || 0),
      0
    );
    const vatTotal = (values.transactionsLinesList || []).reduce(
      (sum: number, line: any) => sum + Number(line.vatAmount || 0),
      0
    );
    return formatNumber(total + vatTotal);
  };

  const inventoryOptions = useMemo(
    () =>
      data.map(m => ({
        label: i18n.language === 'en' ? m.inventoryName : m.inventoryName2,
        value: m.inventoryId
      })),
    [data, i18n.language]
  );

  const nonInventoryOptions = useMemo(() => NonInventoryItemsOptions as any[], [NonInventoryItemsOptions]);

  const totals = {
    subtotal: calculateTotalSum(),
    vat: calculateVatSum(),
    total: calculateNetTotal()
  };

  return (
    <Loading loading={loading} error={error} Type='Dots'>
      <Card className='mb-4 border-0'>
        {/* Header Section */}
        <div className='card-header d-flex justify-content-between align-items-center'>
          <h6 className='mb-0'>
            <i className='fas fa-warehouse me-2'></i>
            {t('بنود أمر الشراء متعدد المخازن')}
            <span className='badge bg-primary ms-2'>مخازن متعددة</span>
          </h6>
          <div>
            <span className='badge bg-theme me-2'>عدد البنود: {(values.transactionsLinesList || []).length}</span>
            <button type='button' className='btn btn-theme btn-sm' onClick={handleAddLine}>
              <i className='fas fa-plus me-2'></i>
              {t('إضافة بند جديد')}
            </button>
          </div>
        </div>

        {/* Summary Section */}
        <div className='card-body p-3'>
          <div className='bg-inverse bg-opacity-10 p-3 rounded-0'>
            <div className='d-flex flex-wrap gap-4 justify-content-between'>
              <div className='d-flex gap-2 align-items-center'>
                <span className='fw-bold'>{t('الإجمالي')}:</span>
                <span className='fw-bold'>{totals.subtotal}</span>
              </div>
              <div className='d-flex gap-2 align-items-center'>
                <span className='fw-bold'>{t('VAT')}:</span>
                <span className='fw-bold text-warning'>{totals.vat}</span>
              </div>
              <div className='d-flex gap-2 align-items-center'>
                <span className='fw-bold'>{t('الصافي')}:</span>
                <span className='text-theme fs-5 fw-bold'>{totals.total}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Table Section */}
        <div className='card-body p-0'>
          <div
            className='table-responsive'
            style={{
              maxHeight: maxTableHeight,
              overflow: 'auto',
              position: 'relative'
            }}
          >
            <table className='table table-hover mb-0' style={{ minWidth: '1400px' }}>
              <thead
                className='table-actived fw-bold'
                style={{
                  position: 'sticky',
                  top: 0,
                  zIndex: 100,
                  backgroundColor: 'var(--bs-table-bg)',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                }}
              >
                <tr>
                  <th
                    className='text-center small'
                    style={{
                      width: '50px',
                      minWidth: '50px',
                      position: 'sticky',
                      left: 0,
                      backgroundColor: 'var(--bs-table-bg)',
                      zIndex: 101,
                      boxShadow: '2px 0 4px rgba(0,0,0,0.1)'
                    }}
                  >
                    #
                  </th>
                  <th className='text-center small' style={{ width: '120px', minWidth: '120px' }}>
                    {t('نوع الصنف')}
                  </th>
                  <th className='text-center small' style={{ width: '250px', minWidth: '250px' }}>
                    {t('المخـزن')}
                  </th>
                  <th className='text-center small' style={{ width: '300px', minWidth: '300px' }}>
                    {t('الصنف')}
                  </th>
                  <th className='text-center small' style={{ width: '120px', minWidth: '120px' }}>
                    {t('الوحدة')}
                  </th>
                  <th className='text-center small' style={{ width: '100px', minWidth: '100px' }}>
                    {t('الكمية')}
                  </th>
                  <th className='text-center small' style={{ width: '120px', minWidth: '120px' }}>
                    {t('السعر')}
                  </th>
                  <th className='text-center small' style={{ width: '100px', minWidth: '100px' }}>
                    {t('نسبة الخصم')}
                  </th>
                  <th className='text-center small' style={{ width: '120px', minWidth: '120px' }}>
                    {t('قيمة الخصم')}
                  </th>
                  <th className='text-center small' style={{ width: '80px', minWidth: '80px' }}>
                    VAT %
                  </th>
                  <th className='text-center small' style={{ width: '120px', minWidth: '120px' }}>
                    {t('VAT')}
                  </th>
                  <th className='text-center small' style={{ width: '120px', minWidth: '120px' }}>
                    {t('Total')}
                  </th>
                  <th className='text-center small' style={{ width: '50px', minWidth: '50px' }}></th>
                </tr>
              </thead>

              <tbody>
                {(values.transactionsLinesList || []).length > 0 ? (
                  (values.transactionsLinesList || []).map((line: any, index: number) => {
                    const isNonInventory = line.itemType !== 'InventoryItem';

                    return (
                      <tr key={index}>
                        <td
                          className='text-center align-middle'
                          style={{
                            position: 'sticky',
                            left: 0,
                            backgroundColor: 'var(--bs-body-bg)',
                            zIndex: 50,
                            boxShadow: '2px 0 4px rgba(0,0,0,0.1)'
                          }}
                        >
                          <span className='badge bg-theme bg-opacity-30 fw-bold' style={{ fontSize: '0.85rem' }}>
                            {index + 1}
                          </span>
                        </td>

                        {/* نوع الصنف */}
                        <td className='align-middle'>
                          <select
                            className='form-select form-select-sm border-theme'
                            value={line.itemType || ''}
                            onChange={e => handleLineChange(index, 'itemType', e.target.value)}
                            style={{ width: '100%' }}
                          >
                            <option value='InventoryItem'>{i18n.language === 'en' ? 'Inventory' : 'مخزني'}</option>
                            <option value='ExpenseItem'>{i18n.language === 'en' ? 'Expense' : 'مصروف'}</option>
                            <option value='FixedAssetItem'>{i18n.language === 'en' ? 'Fixed Asset' : 'أصل'}</option>
                            <option value='ServiceItem'>{i18n.language === 'en' ? 'Service' : 'خدمي'}</option>
                          </select>
                        </td>

                        {/* المخزن */}
                        <td className='align-middle'>
                          <div style={{ width: '100%' }}>
                            <Select
                              isDisabled={isNonInventory}
                              classNamePrefix='react-select'
                              className='react-select-container'
                              isSearchable
                              isClearable
                              options={inventoryOptions}
                              onChange={option => handleLineChange(index, 'inventoryId', option === null ? null : option.value)}
                              value={
                                line.inventoryId === null
                                  ? null
                                  : inventoryOptions.find((option: any) => option.value === line.inventoryId)
                              }
                              placeholder={i18n.language === 'ar' ? 'اختر المخزن...' : 'Select Inventory...'}
                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
                                control: (base: any) => ({
                                  ...base,
                                  minHeight: '31px',
                                  height: '31px',
                                  width: '100%',
                                  borderColor: isNonInventory ? '#e9ecef' : '#ced4da',
                                  backgroundColor: isNonInventory ? '#f8f9fa' : 'white',
                                  cursor: isNonInventory ? 'not-allowed' : 'pointer'
                                })
                              }}
                              menuPlacement='auto'
                            />
                          </div>
                        </td>

                        {/* الصنف */}
                        <td className='align-middle'>
                          <div style={{ width: '100%' }}>
                            {line.itemType === 'InventoryItem' ? (
                              <Select
                                classNamePrefix='react-select'
                                className='react-select-container'
                                isSearchable
                                isClearable
                                options={getItemData(line.inventoryId)}
                                onChange={option => handleLineChange(index, 'itemId', option === null ? null : option.value)}
                                value={
                                  line.itemId === null
                                    ? null
                                    : getItemData(line.inventoryId).find((option: any) => option.value === line.itemId)
                                }
                                placeholder={i18n.language === 'ar' ? 'اختر الصنف...' : 'Select Item...'}
                                menuPortalTarget={document.body}
                                styles={{
                                  menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
                                  control: (base: any) => ({
                                    ...base,
                                    minHeight: '31px',
                                    height: '31px',
                                    width: '100%',
                                    borderColor: !line.inventoryId ? '#e9ecef' : '#ced4da',
                                    backgroundColor: !line.inventoryId ? '#f8f9fa' : 'white',
                                    cursor: !line.inventoryId ? 'not-allowed' : 'pointer'
                                  })
                                }}
                                menuPlacement='auto'
                              />
                            ) : (
                              <Select
                                classNamePrefix='react-select'
                                className='react-select-container'
                                isSearchable
                                isClearable
                                options={nonInventoryOptions.filter((item: any) => item.itemType === line.itemType)}
                                onChange={option => handleLineChange(index, 'itemId', option === null ? null : option.value)}
                                value={
                                  line.itemId === null
                                    ? null
                                    : nonInventoryOptions
                                        .filter((item: any) => item.itemType === line.itemType)
                                        .find((option: any) => option.value === line.itemId)
                                }
                                placeholder={i18n.language === 'ar' ? 'اختر الصنف...' : 'Select Item...'}
                                menuPortalTarget={document.body}
                                styles={{
                                  menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
                                  control: (base: any) => ({
                                    ...base,
                                    minHeight: '31px',
                                    height: '31px',
                                    width: '100%',
                                    borderColor: '#ced4da'
                                  })
                                }}
                              />
                            )}
                          </div>
                        </td>

                        {/* الوحدة */}
                        <td className='align-middle'>
                          {line.itemType === 'InventoryItem' ? (
                            <select
                              disabled={!line.itemId}
                              className={`form-select form-select-sm ${!line.itemId ? 'bg-light' : ''} border-theme`}
                              value={line.uom || ''}
                              onChange={e => handleLineChange(index, 'uom', e.target.value)}
                              style={{ width: '100%' }}
                            >
                              <option value=''>{i18n.language === 'ar' ? 'اختر الوحدة' : 'Select UOM'}</option>
                              {getItemData(line.inventoryId)
                                .filter((f: any) => f.itemId === line.itemId)
                                ?.map((item: any, idx: any) => (
                                  <option key={idx} value={item.uom}>
                                    {item.uomName}
                                  </option>
                                ))}
                            </select>
                          ) : (
                            <select
                              disabled={!line.itemId}
                              className='form-select form-select-sm border-theme'
                              value={line.uom || ''}
                              onChange={e => handleLineChange(index, 'uom', e.target.value)}
                              style={{ width: '100%' }}
                            >
                              <option value=''>{i18n.language === 'ar' ? 'اختر الوحدة' : 'Select UOM'}</option>
                              {nonInventoryOptions
                                ?.filter((f: any) => f.itemId === line.itemId)
                                ?.map((item: any, idx: any) => (
                                  <option key={idx} value={item.uom}>
                                    {item.uomName || item.uom}
                                  </option>
                                ))}
                            </select>
                          )}
                        </td>

                        {/* باقي الحقول */}
                        <td className='align-middle'>
                          <NumericFormat
                            name={`line-${index}-qty`}
                            value={line.qty}
                            thousandSeparator=','
                            decimalSeparator='.'
                            decimalScale={2}
                            fixedDecimalScale={false}
                            allowNegative={false}
                            className='form-control form-control-sm border-theme'
                            onValueChange={v => handleLineChange(index, 'qty', v.floatValue ?? 0)}
                            disabled={!line.itemId}
                            style={{ width: '100%' }}
                          />
                        </td>

                        <td className='align-middle'>
                          <NumericFormat
                            name={`line-${index}-price`}
                            value={line.price}
                            thousandSeparator=','
                            decimalSeparator='.'
                            decimalScale={2}
                            fixedDecimalScale={false}
                            allowNegative={false}
                            className='form-control form-control-sm border-theme'
                            onValueChange={v => handleLineChange(index, 'price', v.floatValue ?? 0)}
                            disabled={!line.itemId}
                            style={{ width: '100%' }}
                          />
                        </td>

                        <td className='align-middle'>
                          <NumericFormat
                            name={`line-${index}-discountRate`}
                            value={line.discountRate}
                            thousandSeparator=','
                            decimalSeparator='.'
                            decimalScale={2}
                            fixedDecimalScale={false}
                            allowNegative={false}
                            isAllowed={v => v.floatValue === undefined || v.floatValue <= 100}
                            className='form-control form-control-sm border-theme'
                            onValueChange={v => handleLineChange(index, 'discountRate', v.floatValue ?? 0)}
                            disabled={!line.itemId}
                            style={{ width: '100%' }}
                          />
                        </td>

                        <td className='align-middle fw-bold text-danger text-center'>
                          <div style={{ width: '100%' }}>
                            {formatNumber(line.discountAmount || 0)}
                          </div>
                        </td>

                        <td className='align-middle'>
                          <NumericFormat
                            name={`line-${index}-vatRate`}
                            value={line.vatRate}
                            thousandSeparator=','
                            decimalSeparator='.'
                            decimalScale={2}
                            fixedDecimalScale={false}
                            allowNegative={false}
                            isAllowed={v => v.floatValue === undefined || v.floatValue <= 100}
                            className='form-control form-control-sm border-theme'
                            onValueChange={v => handleLineChange(index, 'vatRate', v.floatValue ?? 0)}
                            disabled={!line.itemId}
                            style={{ width: '100%' }}
                          />
                        </td>

                        <td className='align-middle fw-bold text-warning text-center'>
                          <div style={{ width: '100%' }}>
                            {formatNumber(line.vatAmount || 0)}
                          </div>
                        </td>

                        <td className='align-middle'>
                          <div style={{ width: '100%' }}>
                            <strong className='text-theme fs-6'>
                              {formatNumber(line.total || 0)}
                            </strong>
                          </div>
                        </td>

                        <td className='align-middle text-center'>
                          <button
                            type='button'
                            className='btn btn-sm btn-outline-danger rounded-circle'
                            onClick={() => handleDeleteLine(index)}
                            title={t('Delete Line')}
                            style={{
                              width: '28px',
                              height: '28px',
                              padding: '0'
                            }}
                          >
                            <i className='fas fa-times'></i>
                          </button>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={13} className='text-center py-4 text-muted'>
                      <i className='fa fa-inbox fa-2x mb-2'></i>
                      <br />
                      {t('لا توجد بنود مضافة لهذا الطلب')}
                      <br />
                      <button type='button' className='btn btn-theme mt-3' onClick={handleAddLine}>
                        <i className='fas fa-plus me-2'></i>
                        {t('إضافة أول بند')}
                      </button>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Scroll Indicator */}
          {(values.transactionsLinesList || []).length > 5 && (
            <div className='mt-2 text-center'>
              <small className='text-muted'>
                <i className='fas fa-arrows-alt-v me-1'></i>
                {t('اسحب لرؤية المزيد من البنود')}
              </small>
            </div>
          )}
        </div>

        {/* Footer Section */}
        <div className='card-footer d-flex justify-content-between align-items-center'>
          <div className='text-muted small'>
            <i className='fas fa-list me-1'></i>
            عرض {(values.transactionsLinesList || []).length} من {(values.transactionsLinesList || []).length} بند
          </div>
          <div className='text-theme fw-bold'>
            <i className='fas fa-calculator me-2'></i>
            إجمالي الطلب: {totals.total}
          </div>
        </div>
      </Card>
    </Loading>
  );
};

export default PoMultiInvLines;